import PinnedNote from 'components/PinnedNote/PinnedNote';
import { connect } from 'react-redux';
import { updateNote } from 'actions/notes';
import { getNotes } from 'reducers';

const mapStateToProps = (state) => ({
  notes: getNotes(state),
});

const mapDispatchToProps = { updateNote };

export default connect(mapStateToProps, mapDispatchToProps)(PinnedNote);
